"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Menu = _interopRequireDefault(require("../Menu"));
var _MenuItem = _interopRequireDefault(require("../MenuItem"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Alignment = {
  left: 'DropdownMenuContentLeft',
  right: 'DropdownMenuContentRight'
};
var defaultProps = {
  onChange: function onChange() {},
  placeholder: 'Select',
  labelKey: 'label',
  theme: {},
  options: [],
  alignment: 'left'
};

/**
 * Provides a dropdown used to select a single option.
 */
var DropdownMenu = exports["default"] = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(DropdownMenu, _Component);
  function DropdownMenu(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, DropdownMenu);
    _this = _callSuper(this, DropdownMenu, [props]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleGlobalMouseDown", function (event) {
      var isTargetInDropdown = _this.dropdownRef && _this.dropdownRef.contains(event.target);
      if (!isTargetInDropdown) {
        _this.closeDropdown();
      }
    });
    _this.state = {
      selected: DropdownMenu.findSelected(props.value, props.options, props.valueKey),
      isDropdownOpen: false
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleDropdown = _this.toggleDropdown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.closeDropdown = _this.closeDropdown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderOption = _this.renderOption.bind((0, _assertThisInitialized2["default"])(_this));
    _this.optionsRefs = [];
    return _this;
  }
  (0, _createClass2["default"])(DropdownMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleGlobalMouseDown, true);
    }

    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
        value = _this$props.value,
        options = _this$props.options,
        valueKey = _this$props.valueKey;
      if (nextProps.value && nextProps.value !== value || nextProps.options && nextProps.options !== options) {
        this.optionsRefs = [];
        this.setState({
          selected: DropdownMenu.findSelected(nextProps.value, nextProps.options, valueKey)
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleGlobalMouseDown);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e, value) {
      e.stopPropagation();
      var valueKey = this.props.valueKey;
      this.setState({
        selected: value,
        isDropdownOpen: false
      });
      if (typeof value.onClick === 'function') {
        value.onClick();
      }
      this.props.onChange({
        value: valueKey ? value[valueKey] : value
      });
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      var isDropdownOpen = this.state.isDropdownOpen;
      this.setState({
        isDropdownOpen: !isDropdownOpen
      });
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown() {
      this.setState({
        isDropdownOpen: false
      });
    }
  }, {
    key: "focusNextOption",
    value: function focusNextOption(getNextIndex) {
      var _this2 = this;
      this.setState(function (prevState, props) {
        var index = props.options.indexOf(prevState.selected);
        var nextIndex = getNextIndex(index, props.options);
        var nextOption = props.options[nextIndex];
        while (nextIndex !== index && (nextOption === DropdownMenu.Separator || nextOption.type === 'label')) {
          nextIndex = getNextIndex(nextIndex, props.options);
          nextOption = props.options[nextIndex];
        }
        if (nextIndex === index) {
          return prevState;
        }
        _this2.optionsRefs[nextIndex].focus();
        return {
          selected: nextOption
        };
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.toggleDropdown();
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeDropdown();
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (!this.state.isDropdownOpen) {
          this.toggleDropdown();
          return;
        }
        var getIndexFn;
        if (event.key === 'ArrowUp') {
          getIndexFn = DropdownMenu.getPreviousIndex;
        } else if (event.key === 'ArrowDown') {
          getIndexFn = DropdownMenu.getNextIndex;
        }
        this.focusNextOption(getIndexFn);
      }
    }
  }, {
    key: "renderOption",
    value: function renderOption(option, index) {
      var _this3 = this;
      var _this$props2 = this.props,
        labelKey = _this$props2.labelKey,
        testId = _this$props2.testId,
        theme = _this$props2.theme;
      var isSeparator = option === DropdownMenu.Separator;
      var isOptionSelected = this.state.selected === option;
      if (isSeparator) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: theme.separator,
          key: index
        });
      }
      if (option.type === 'label') {
        return /*#__PURE__*/_react["default"].createElement("span", {
          key: index,
          className: theme.label
        }, option[labelKey]);
      }
      return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        getRef: function getRef(element) {
          _this3.optionsRefs[index] = element;
        },
        role: "menuitem",
        className: (0, _classnames["default"])(theme.DropdownMenuItem, (0, _defineProperty2["default"])({}, theme.selected, isOptionSelected)),
        tabIndex: "-1",
        testId: testId && "".concat(testId, "-list-item"),
        onClick: function onClick(e) {
          return _this3.handleChange(e, option);
        },
        key: index,
        icon: option.icon
      }, DropdownMenu.renderItemLabel(labelKey, option));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props3 = this.props,
        id = _this$props3.id,
        options = _this$props3.options,
        labelKey = _this$props3.labelKey,
        placeholder = _this$props3.placeholder,
        className = _this$props3.className,
        testId = _this$props3.testId,
        theme = _this$props3.theme,
        alignment = _this$props3.alignment,
        ariaLabel = _this$props3['aria-label'],
        ariaLabelledBy = _this$props3.ariaLabelledBy;
      var _this$state = this.state,
        selected = _this$state.selected,
        isDropdownOpen = _this$state.isDropdownOpen;
      var menuAlignment = Alignment[alignment.toLowerCase()] || Alignment.left;
      return (
        /*#__PURE__*/
        // TODO: Next breaking change we should the following unused classes:
        // DropdownMenuToggle
        // DropdownMenuMenu
        _react["default"].createElement("div", {
          id: id,
          ref: function ref(r) {
            _this4.dropdownRef = r;
          },
          role: "listbox",
          className: (0, _classnames["default"])(theme.DropdownMenu, theme.DropdownMenuToggle, className),
          "data-anypoint-component": DropdownMenu.displayName,
          "data-test-id": testId,
          onMouseDown: this.toggleDropdown,
          onKeyDown: this.handleKeyDown,
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          tabIndex: "0"
        }, selected ? DropdownMenu.renderItemLabel(labelKey, selected, true) : null, !selected ? /*#__PURE__*/_react["default"].createElement("span", null, placeholder) : null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          className: theme.DropdownMenuIcon,
          name: "arrow-down-small",
          size: ""
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])(theme.DropdownMenuContent, theme[menuAlignment]),
          "data-test-id": testId && "".concat(testId, "-content")
        }, isDropdownOpen ? /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
          className: theme.DropdownMenuMenu
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: theme.headItem
        }, selected ? DropdownMenu.renderItemLabel(labelKey, selected) : /*#__PURE__*/_react["default"].createElement("span", {
          role: "option",
          "aria-selected": true
        }, placeholder), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          className: theme.DropdownMenuIcon,
          name: "arrow-down-small",
          size: ""
        })), /*#__PURE__*/_react["default"].createElement("ul", {
          "data-test-id": testId && "".concat(testId, "-list"),
          className: theme.list
        }, options.map(this.renderOption))) : null))
      );
    }
  }], [{
    key: "cloneIgnoringTabs",
    value:
    // Clone an element but with the prop tabIndex value -1
    function cloneIgnoringTabs(element) {
      if (!element || !element.props) {
        return element;
      }
      return /*#__PURE__*/_react["default"].cloneElement(element, {
        tabIndex: '-1'
      }, _react["default"].Children.map(element.props.children, function (child) {
        return DropdownMenu.cloneIgnoringTabs(child);
      }));
    }
  }, {
    key: "renderItemLabel",
    value: function renderItemLabel(labelKey, selected, ignoreTabs) {
      // Underscore.js isFunction approach
      // (see https://github.com/jashkenas/underscore/blob/master/underscore.js#L1337)
      var isFunction = typeof labelKey === 'function';
      var label = isFunction ? labelKey(selected) : selected && selected[labelKey] || selected;

      // We should ignore tabs only when we are rendering the label
      // that is used as a sample when the dropdown is not open
      return /*#__PURE__*/_react["default"].createElement("span", null, ignoreTabs ? DropdownMenu.cloneIgnoringTabs(label) : label);
    }
  }, {
    key: "findSelected",
    value: function findSelected(value, options, valueKey) {
      var selectedOptions = options.filter(function (option) {
        if (option === value) {
          return true;
        }

        // UIFX-1130: We need to filter out all options that have no "valueKey" at all.
        // For example, Separator option has only "type" field.
        // And it can be defined as selected option when value equals to "undefined".
        // As result, it will break "renderItemLabel" method.
        if (!valueKey || !(valueKey in option)) {
          return false;
        }
        return option[valueKey] === value;
      });
      return selectedOptions[0];
    }
  }, {
    key: "getNextIndex",
    value: function getNextIndex(index, options) {
      return index === options.length - 1 ? 0 : index + 1;
    }
  }, {
    key: "getPreviousIndex",
    value: function getPreviousIndex(index, options) {
      return index === 0 ? options.length - 1 : index - 1;
    }
  }]);
  return DropdownMenu;
}(_react.Component);
(0, _defineProperty2["default"])(DropdownMenu, "Separator", {
  type: 'separator'
});
(0, _defineProperty2["default"])(DropdownMenu, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(DropdownMenu, "displayName", 'DropdownMenu');
//# sourceMappingURL=DropdownMenu.js.map